import React from "react";
import { Activity, Gauge, Sparkles } from "lucide-react";
import { Button, Card, DataTable, StatusBadge } from "../components/ui";

export default function Demo() {
  const dadosExemplo = [
    { id: 1, nome: "João Silva", email: "joao@exemplo.com", cargo: "admin", ativo: true },
    { id: 2, nome: "Maria Santos", email: "maria@exemplo.com", cargo: "user", ativo: true },
    { id: 3, nome: "Pedro Costa", email: "pedro@exemplo.com", cargo: "user", ativo: false },
  ];

  const columns = [
    { key: "nome", header: "Nome" },
    { key: "email", header: "Email" },
    {
      key: "cargo",
      header: "Cargo",
      render: (value) => (
        <StatusBadge
          status={value === "admin" ? "Administrador" : "Comercial"}
          variant={value === "admin" ? "info" : "default"}
        />
      ),
    },
    {
      key: "ativo",
      header: "Status",
      render: (value) => (
        <StatusBadge status={value ? "Ativo" : "Inativo"} variant={value ? "success" : "danger"} />
      ),
    },
  ];

  const actions = [
    { icon: "bi-pencil", title: "Editar", onClick: (item) => console.log("Editar", item) },
    { icon: "bi-eye", title: "Visualizar", onClick: (item) => console.log("Visualizar", item) },
  ];

  return (
    <div className="space-y-4">
      <header className="page-header">
        <h1 className="page-title">Demo de interface</h1>
        <p className="page-subtitle">Pré-visualização dos componentes no padrão mobile-first.</p>
      </header>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
        <Card title="Operação diária">
          <div className="space-y-3 text-sm">
            <div className="flex items-center justify-between">
              <span className="text-muted-foreground">Usuários ativos</span>
              <strong className="text-xl">98</strong>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-muted-foreground">Tarefas concluídas</span>
              <strong className="text-xl">214</strong>
            </div>
          </div>
        </Card>

        <Card title="Ações rápidas">
          <div className="space-y-2">
            <Button variant="outline" className="w-full justify-start">
              <Sparkles className="h-4 w-4" />
              Novo parceiro
            </Button>
            <Button variant="outline" className="w-full justify-start">
              <Activity className="h-4 w-4" />
              Nova tarefa
            </Button>
          </div>
        </Card>

        <Card title="Saúde do sistema">
          <div className="space-y-3 text-sm">
            <div className="flex items-center justify-between">
              <span className="text-muted-foreground">API</span>
              <StatusBadge status="Online" variant="success" />
            </div>
            <div className="flex items-center justify-between">
              <span className="text-muted-foreground">Fila de eventos</span>
              <StatusBadge status="Normal" variant="info" />
            </div>
            <div className="flex items-center justify-between">
              <span className="text-muted-foreground">Latência média</span>
              <span className="inline-flex items-center gap-1 font-medium">
                <Gauge className="h-4 w-4" />
                112 ms
              </span>
            </div>
          </div>
        </Card>
      </div>

      <Card title="Tabela de exemplo">
        <DataTable columns={columns} data={dadosExemplo} actions={actions} enablePagination={false} />
      </Card>
    </div>
  );
}
